import { render } from "./App.vue?vue&type=template&id=c862dc0e"
const script = {}

import exportComponent from "/Users/Junior/ProjectPile/smartpile-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__